import ScienceIcon from '@mui/icons-material/Science';

export const SampleMenuIcon = () => <ScienceIcon />;
